
export const canonicalizeTitle = title => {
  return title.split(' ').join('_')
}
